import digitalData from 'digital-data';
import {
  STASH, OVERLAY, NOT_APPLICABLE, RECOMMENDATION_EVENTNAME, BUNDLE_QUICK_VIEW, SP
} from '../constants';
import { getRecommendationType } from '../thd-analytics-utils';

export const bundleQuickView = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('bundle-quick-view.openQuickView', ({ output }) => {
    const { product } = output ?? {};
    const analyticsEvent = {
      category: {
        primaryCategory: OVERLAY,
      },
      eventInfo: {
        eventName: BUNDLE_QUICK_VIEW,
      },
      item: [
        {
          sku: product?.itemId
        }
      ]
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('bundle-quick-view.openQuickViewFromRecs', ({ output }) => {
    const pageType = digitalData?.page?.pageInfo?.pageType || '';
    const { bundle, product } = output ?? {};
    const isSponsored = product?.info?.isSponsored || false;
    const analyticsEvent = {
      category: {
        primaryCategory: STASH,
      },
      eventInfo: {
        eventName: RECOMMENDATION_EVENTNAME,
      },
      eventMode: STASH,
      stash: {
        recommendation: {
          pageType,
          recommendationType: getRecommendationType(bundle),
          recommendationVersion: NOT_APPLICABLE,
          displayPosition: NOT_APPLICABLE,
          anchorProductSku: product?.itemId,
          strategy: NOT_APPLICABLE,
          featureVersion: NOT_APPLICABLE,
          interval: NOT_APPLICABLE,
          sponsoredProduct: isSponsored ? SP : NOT_APPLICABLE
        },
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(analyticsEvent);
  });
};